// extracted by mini-css-extract-plugin
export default {"container":"ekhA5","noSeparators":"BecW5","section":"zqsHa","socialActions":"IT0VQ","mainSection":"bokv6","bottomSection":"vMux6","stats":"B5X7s","comments":"_8KdGs"};